import createIcon from '../../createIcon';

/**
 * @component @name PictureInPicture
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNy4wMTAwMUgxMVYxMy4wMUgxOVY3LjAxMDAxWk0yMSAzLjAxMDAxSDNDMS45IDMuMDEwMDEgMSAzLjkxMDAxIDEgNS4wMTAwMVYxOS4wMUMxIDIwLjExIDEuOSAyMC45OSAzIDIwLjk5SDIxQzIyLjEgMjAuOTkgMjMgMjAuMTEgMjMgMTkuMDFWNS4wMTAwMUMyMyAzLjkxMDAxIDIyLjEgMy4wMTAwMSAyMSAzLjAxMDAxWk0yMSAxOS4wMkgzVjQuOTkwMDFIMjFWMTkuMDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PictureInPicture = createIcon('PictureInPicture', [
  [
    'path',
    {
      d: 'M19 7.01001H11V13.01H19V7.01001ZM21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.91001 22.1 3.01001 21 3.01001ZM21 19.02H3V4.99001H21V19.02Z',
      key: 'r2r9p5',
    },
  ],
]);

export default PictureInPicture;
